import React from "react";
import { FaExclamationTriangle, FaTrashAlt, FaTimes } from "react-icons/fa";

interface DiscardDraftModalProps {
    open: boolean;
    onClose: () => void;
    onConfirm: () => void;
}

const DiscardDraftModal: React.FC<DiscardDraftModalProps> = ({
    open,
    onClose,
    onConfirm,
}) => {
    if (!open) return null;

    return (
        <div
            className="modal fade show d-flex align-items-center justify-content-center"
            tabIndex={-1}
            role="dialog"
            style={{
                backgroundColor: "rgba(0, 0, 0, 0.55)",
                position: "fixed",
                inset: 0,
                zIndex: 1055,
            }}
        >
            <div
                className="modal-dialog modal-dialog-centered"
                style={{
                    maxWidth: "450px",
                    width: "calc(100% - 30px)",
                }}
            >
                <div
                    className="modal-content border-0 shadow-lg"
                    style={{
                        borderRadius: "16px",
                        overflow: "hidden",
                    }}
                >

                    <div className="modal-header border-0 pb-0 d-flex justify-content-between"
                        style={{
                            padding: "24px 24px 10px",
                        }}
                    >
                        <div className="d-flex align-items-center gap-3">
                            <div
                                className="d-flex align-items-center justify-content-center"
                                style={{
                                    width: "48px",
                                    height: "48px",
                                    borderRadius: "50%",
                                    backgroundColor: "#fff1f1",
                                    color: "#dc3545",
                                }}
                            >
                                <FaExclamationTriangle size={22} />
                            </div>

                            <h5 className="modal-title fw-semibold mb-0">
                                Discard Draft
                            </h5>
                        </div>

                        <button
                            type="button"
                            className="border-0 bg-transparent d-flex align-items-center justify-content-center"
                            onClick={onClose}
                            aria-label="Close"
                            style={{
                                width: "32px",
                                height: "32px",
                                color: "#6c757d",
                            }}
                        >
                            <FaTimes size={18} />
                        </button>
                    </div>

                    <div
                        className="modal-body"
                        style={{
                            padding: "16px 24px 24px",
                        }}
                    >
                        <p className="mb-2 fw-medium">
                            Are you sure you want to discard this draft?
                        </p>

                        <p
                            className="text-muted mb-0"
                            style={{
                                fontSize: "14px",
                                lineHeight: "1.6",
                            }}
                        >
                            Once discarded, the media file and minutes will be
                            permanently deleted and cannot be recovered or
                            submitted again.
                        </p>
                    </div>

                    <div
                        className="modal-footer border-0 pt-0"
                        style={{
                            padding: "0 24px 24px",
                        }}
                    >
                        <button
                            type="button"
                            className="btn btn-light border d-flex align-items-center justify-content-center gap-2"
                            onClick={onClose}
                            style={{
                                minWidth: "110px",
                                borderRadius: "8px",
                            }}
                        >
                            <FaTimes size={13} />
                            Cancel
                        </button>

                        <button
                            type="button"
                            className="btn btn-danger d-flex align-items-center justify-content-center gap-2"
                            onClick={onConfirm}
                            style={{
                                minWidth: "140px",
                                borderRadius: "8px",
                            }}
                        >
                            <FaTrashAlt size={14} />
                            Discard Draft
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DiscardDraftModal;